"use client"

import { useRef, useState } from "react"
import { extractProperty, ProjectPage, useOutsideClick } from "utils"
import { RentProjectContactText } from "utils/projects"
import { Backdrop, StickyCTAWrap } from "../StandardProject"
import StickyCTA from "../StickyCTA"
import DrawerContactForm from "../Marketing/ApartmentMarketingForRent/DrawerContactForm"
import { ProjectsMessages } from "../Projects"
import { normalizeArray, normalizeString, preferValue } from "./masterBlockUtils"

type Props = {
  data?: any
  projectData: ProjectPage
  locale: string
  messages: ProjectsMessages
  formSubjects: Record<string, string>
}

const mapBlockContactText = (data: any): RentProjectContactText => {
  return {
    contactButton: normalizeString(extractProperty(data, "contactButton")) || undefined,
    leadButton: normalizeString(extractProperty(data, "leadButton")) || undefined,
    meetingButton: normalizeString(extractProperty(data, "meetingButton")) || undefined,
    callButton: normalizeArray(extractProperty(data, "callButton")),
  }
}

const mergeContactText = (
  blockText: RentProjectContactText,
  projectText?: RentProjectContactText,
): RentProjectContactText => {
  return {
    contactButton: preferValue(blockText.contactButton, projectText?.contactButton),
    leadButton: preferValue(blockText.leadButton, projectText?.leadButton),
    meetingButton: preferValue(blockText.meetingButton, projectText?.meetingButton),
    callButton: preferValue(blockText.callButton, projectText?.callButton),
  }
}

function MasterRentStickyCta({ data, projectData, locale, messages, formSubjects }: Props) {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
  const [isBackdropVisible, setIsBackdropVisible] = useState(false)
  const [isDropDownOpen, setIsDropDownOpen] = useState(false)
  const stickyRef = useRef(null)
  const formRef = useRef(null)

  const handleBackdropClose = () => {
    setDrawerOpen(false)
    setIsBackdropVisible(false)
    setIsDropDownOpen(false)
  }

  useOutsideClick([stickyRef, formRef], handleBackdropClose)

  if (!messages || !formSubjects) {
    return null
  }

  const blockContactText = data ? mapBlockContactText(data) : ({} as RentProjectContactText)
  const mergedContactText = mergeContactText(blockContactText, projectData?.rentProjectContactText)

  const mergedProjectData: ProjectPage = {
    ...projectData,
    rentProjectContactText: mergedContactText,
  }

  if (mergedProjectData.hideLeadForm) {
    return null
  }

  return (
    <>
      {isBackdropVisible && <Backdrop />}
      <StickyCTAWrap ref={stickyRef} z={drawerOpen ? 90 : 100} className={"newStyle"}>
        <StickyCTA
          projectType={mergedProjectData.projectType}
          messages={messages}
          setIsBackdropVisible={setIsBackdropVisible}
          open={isDropDownOpen}
          setIsFormVisible={setDrawerOpen}
          setIsDropDownOpen={setIsDropDownOpen}
          phone={mergedProjectData.phone}
          phoneName={mergedProjectData.phoneName}
          miniSite={mergedProjectData.miniSite}
          bmbyMeetingId={mergedProjectData.bmbyMeetingId}
          virtualTourLink={mergedProjectData.virtualTourLink}
          virtualTourLinkName={mergedProjectData.virtualTourLinkName}
          isForMarketingRentPage
          locale={locale}
          rentProjectContactText={mergedContactText}
          hideLeadForm={mergedProjectData.hideLeadForm}
        />
      </StickyCTAWrap>
      <DrawerContactForm
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        formProps={{
          messages,
          formSubjects,
          onClose: handleBackdropClose,
          bmbyId: mergedProjectData?.leadFormBMBYId,
          status: mergedProjectData?.projectStatuses[0]?.name,
          companyId: mergedProjectData?.companyId,
          emailForLead: mergedProjectData?.emailForLead,
          newStyle: true,
          type: "contact-marketing-4-rent",
        }}
      />
    </>
  )
}

export default MasterRentStickyCta
